import type {
  AppEnv,
  ClientApplicationConfigOptions,
  ServerApplicationConfigOptions,
} from '@hc-frontend/core-context';

import { applicationErrors } from './errors';

export const config: ServerApplicationConfigOptions &
  ClientApplicationConfigOptions = {
  sessionManagerSrc: {
    src: process.env.NEW_SESSION_SERVICE_SRC ?? '',
  },
  sessionApi: {
    baseUrl: process.env.NEW_SESSION_SERVICE_BASE_URL ?? '',
  },
  quotesApi: {
    baseUrl: process.env.QUOTES_URL ?? '',
  },
  datadog: {
    apiKey: process.env.DATADOG_API_KEY ?? '',
    service: process.env.DATADOG_SERVICE ?? '',
    applicationId: process.env.DATADOG_APPLICATION_ID ?? '',
    clientToken: process.env.DATADOG_CLIENT_TOKEN ?? '',
  },
  errors: applicationErrors,
  texts: {},
  core: {
    appBaseUrl: process.env.HEALTHCARE_URL ?? '',
    sseUrl: process.env.SSE_URL ?? '',
    appEnvironment: (process.env.APP_ENV ?? 'local') as AppEnv,
    nodeEnv: process.env.NODE_ENV ?? '',
    version: process.env.APP_VERSION ?? '0.0.1',
  },
  assets: {
    marketplaceStaticBaseUrl: process.env.MARKETPLACE_STATIC_BASE_URL ?? '',
    sessionScriptUrl: process.env.HC_SESSION_SCRIPT_URL ?? '',
  },
  amplitude: {
    identify: {
      apiKey: process.env.AMPLITUDE_IDENTIFY_API_KEY ?? '',
      baseUrl: process.env.AMPLITUDE_IDENTIFY_BASE_URL ?? '',
    },
    server: {
      apiKey: process.env.AMPLITUDE_CLIENT_API_KEY ?? '',
    },
  },
  sem: {
    apiURL: process.env.PUBLIC_SEM_CONTENT_URL ?? '',
  },
  leadStorageApi: {
    baseUrl: process.env.LEAD_STORAGE_URL ?? '',
  },
  cdn: {
    baseUrl: process.env.CDN_URL ?? '',
  },
  links: {
    membersHealthcareUrl: process.env.MEMBERS_HEALTHCARE_URL ?? '',
  },
  healthcareApi: {
    baseUrl: process.env.HEALTHCARE_API_BASE_URL ?? '',
  },

  reflexiveJourney: {
    baseUrl: process.env.REFLEXIVE_JOURNEY_API ?? '',
  },
  leadsApi: {
    baseUrl: process.env.LEADS_API ?? '',
  },
  thirdParty: {
    baseUrl: process.env.THIRD_PARTY_SERVICE_API ?? '',
  },
  journeyCdnApi: {
    baseUrl: process.env.JOURNEY_CDN_API_URL ?? '',
  },
  journeyCdnApiEnv: {
    baseUrl: process.env.JOURNEY_CDN_API_URL_ENV ?? '',
  },
  geolocationApi: {
    baseUrl: process.env.GEOLOCATION_API_URL ?? '',
  },
  geolocationPublicApi: {
    baseUrl: process.env.GEOLOCATION_PUBLIC_API_URL ?? '',
  },
  geoIpApi: {
    baseUrl: process.env.GEOIP_API_URL ?? '',
  },
  planService: {
    baseUrl: process.env.PLAN_SERVICE_API_URL ?? '',
  },
  snowplow: {
    collector: process.env.SNOWPLOW_COLLECTOR ?? '',
  },
  tcpaConsent: {
    mapping: process.env.TCPA_CONSENT_MAPPING ?? '{}',
    testMapping: process.env.TCPA_CONSENT_TEST_MAPPING ?? '{}',
    medicareEHealthId: process.env.MEDICARE_EHEALTH_PARTNER_ID ?? '',
  },
  mediaAlpha: {
    url: process.env.MEDIA_ALPHA_API_URL ?? '',
    apiToken: process.env.MEDIA_ALPHA_API_TOKEN ?? '',
    healthPlacementId: process.env.MEDIA_ALPHA_HEALTH_PLACEMENT_ID ?? '',
    medicareAdvantagePlacementId:
      process.env.MEDIA_ALPHA_MEDICARE_ADVANTAGE_PLACEMENT_ID ?? '',
    medicareSupplementPlacementId:
      process.env.MEDIA_ALPHA_MEDICARE_SUPPLEMENT_PLACEMENT_ID ?? '',
  },
  quinStreet: {
    url: process.env.QUINSTREET_API_URL ?? '',
    adClientId: process.env.QUINSTREET_AD_CLIENT_ID ?? '',
  },
  butler: {
    url: process.env.BUTLER_API_URL ?? '',
    id: process.env.BUTLER_ID ?? '',
  },
  complianceApi: {
    baseUrl: process.env.COMPLIANCE_API ?? '',
  },
  recaptcha: {
    secret: process.env.RECAPTCHA_SECRET ?? '',
    siteKey: process.env.RECAPTCHA_SITE_KEY ?? '',
  },
  etl: {
    authToken: process.env.ETL_AUTH_TOKEN ?? '',
    url: process.env.ETL_URL ?? '',
  },
  agenticSurveyLandingPage: {
    percentage: Number(
      process.env.AGENTIC_SURVEY_LANDING_PAGE_PERCENTAGE ?? '0',
    ),
    url:
      process.env.AGENTIC_SURVEY_LANDING_PAGE_URL ??
      'https://get.healthcare.com/your-story',
  },
  nova: {
    baseUrl: process.env.NOVA_BASE_URL ?? '',
  },
};
